<!--
 * @Author: lishiqiao
 * @Date: 2022-03-09 10:26:19
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-13 16:47:25
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="params.params.baseId" filterable @change="selectBase" placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖区域&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable @change="selectGroup" placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>养殖单元&nbsp;:</label>
          <el-select v-model="params.params.boxId" filterable placeholder="请选择单元">
            <el-option label="全部单元" value=""></el-option>
            <el-option v-for="item in boxList" :key="item.id" :label="item.boxCode" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>生产造次&nbsp;:</label>
          <el-select v-model="params.params.periodId" filterable placeholder="请选择造次">
            <el-option label="全部造次" value=""></el-option>
            <el-option v-for="item in periodList" :key="item.id" :label="item.year" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>操作类型&nbsp;:</label>
          <el-select v-model="params.params.operationType" filterable placeholder="请选择类型">
            <el-option label="全部类型" value=""></el-option>
            <el-option v-for="item in operationTypeList" :key="item.id" :label="item.reviewType" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>收获时间&nbsp;:</label>
          <el-date-picker v-model="dateRange" :clearable="false" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
            @change="dateChange" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="page-search-item">
          <label>养殖品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.id" :label="item.breedName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>客户&nbsp;:</label>
          <el-select v-model="params.params.clientId" filterable placeholder="请选择客户">
            <el-option label="全部客户" value=""></el-option>
            <el-option v-for="item in customerList" :key="item.id" :label="item.customer" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>记录状态&nbsp;:</label>
          <el-select v-model="params.params.status" filterable placeholder="请选择状态">
            <el-option label="全部状态" value=""></el-option>
            <el-option v-for="item in reviewStatusList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>汇总类型&nbsp;:</label>
          <el-select v-model="params.params.groupType" filterable placeholder="请选择类型">
            <el-option label="全部类型" value=""></el-option>
            <el-option v-for="item in groupTypeList" :key="item.typeId" :label="item.typeName" :value="item.typeId">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>收获记录表</div>
        <div>单位 : {{ unitName }}</div>
        <div>
          日期 :
          {{ showStartDate }}-{{ showEndDate }}
        </div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="switch-table" @click="switchTable">汇总</span>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格-->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="operationDate" label="收获时间">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域分组"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="boxName" label="塘口单元"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="custom" label="客户">
          <template slot-scope="scope">
            {{
              scope.row.operationType !== 29
              ? scope.row.clientName
              : scope.row.saleCustomerName
            }}
          </template>
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[5].fixed" :class-name="fixedColumnList[5].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column prop="batchNumber" label="批次号"> </el-table-column>
        <el-table-column prop="operationTypeName" label="操作类型">
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            {{ scope.row.averageWeight
            }}{{
  scope.row.averageWeightUnitName
  ? `(${scope.row.averageWeightUnitName})`
  : ``
}}
          </template>
        </el-table-column>
        <el-table-column label="单价">
          <template slot-scope="scope">
            {{
              scope.row.operationType !== 29
              ? scope.row.unitPrice
              : scope.row.salePrice
            }}
          </template>
        </el-table-column>
        <el-table-column label="总重量">
          <template slot-scope="scope">
            {{ scope.row.totalWeight }}
            {{
              scope.row.totalWeightUnitName
              ? `(${scope.row.totalWeightUnitName})`
              : ``
            }}
          </template>
        </el-table-column>
        <el-table-column prop="infQua" label="品级"> </el-table-column>
        <el-table-column prop="totalHousing" label="筐数"> </el-table-column>
        <el-table-column prop="totalHousingWeight" label="总皮重">
        </el-table-column>
        <el-table-column label="总净重">
          <template slot-scope="scope">
            {{
              scope.row.operationType !== 29
              ? scope.row.totalNetWeight
              : scope.row.saleWeight
            }}
          </template>
        </el-table-column>
        <el-table-column label="收获数量">
          <template slot-scope="scope">
            {{
              scope.row.operationType !== 29
              ? scope.row.fishNumber
              : scope.row.saleQuantity
            }}
          </template>
        </el-table-column>
        <el-table-column label="总金额">
          <template slot-scope="scope">
            {{
              scope.row.operationType !== 29
              ? scope.row.totalPrice
              : scope.row.saleAmount
            }}
          </template>
        </el-table-column>
        <el-table-column prop="remainingAmount" label="预估存塘量">
        </el-table-column>
        <el-table-column prop="recorder" label="记录人"> </el-table-column>
        <el-table-column prop="buyer" label="经手人"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column prop="reviewStatusName" label="状态">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="uyu-pagination">
        <MyPagination @change="handleCurrentChange($event)" @changeSizes="handleSizeChange($event)"
          :sizes="[13, 26, 39, 50, 100, 200]" :pageNo.sync="params.currPage" :pageSize.sync="params.pageSize"
          :totalCount="totalCount">
        </MyPagination>
      </div>
    </div>
  </div>
</template>

<script>
import MyPagination from "@/components/pc/my-pagination.vue";
import service from "../yc-harvest-service";
import Page from "@/utils/methods/page";
export default {
  name: "yc-harvest-output",
  data() {
    return {
      dateRange: [
        this.$moment().format("YYYY-MM-DD"),
        this.$moment().format("YYYY-MM-DD"),
      ],
      PageDisplay: true,
      unitName: "", // 单位名称
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "operationDate",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "boxName",
          fixed: false,
          selected: false
        },
        {
          prop: "custom",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "operationDate",
        params: {
          orgId: "",
          baseId: "",
          periodId: "",
          groupId: "",
          boxId: "",
          breedId: "",
          operationType: "",
          clientId: "",
          startTime: this.$moment().format("YYYY-MM-DD"),
          endTime: this.$moment().format("YYYY-MM-DD"),
          status: "",
          groupType: "",
        },
      },
      exportParams: {}, // 导出参数
      totalCount: 0, // 总条数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      tableData: [],
      baseList: [], // 基地列表
      groupList: [], // 区域列表
      boxList: [], // 单元列表
      periodList: [], // 造次列表
      operationTypeList: [], // 操作类型列表
      breedList: [], // 品种列表
      customerList: [], // 客户列表
      // 记录状态
      reviewStatusList: [
        {
          id: 0,
          name: "草稿",
        },
        {
          id: 1,
          name: "待审核",
        },
        {
          id: 2,
          name: "已审核",
        },
      ],
      groupTypeList: [], // 汇总类型
    };
  },
  components: { MyPagination },
  // TODO 级联？
  created() {
    this.tableHeight = window.innerHeight - 500;
    this.params.params.orgId = localStorage.getItem("orgId");
    this.getBaseList(); // 获取基地列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 切换汇总表
    switchTable() {
      this.$emit("getPageType", "summary");
    },

    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startTime = val[0];
      this.params.params.endTime = val[1];
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:05:52
     * @description: 获取用户权限基地
     * @param {*}
     */
    getBaseList() {
      service
        .getBaseListsByUser()
        .then((res) => {
          if (res.code == "0000") {
            this.baseList = res.data;
            this.params.params.orgId = this.baseList[0].orgId;
            this.params.params.baseId = this.baseList[0].id;
            this.getGroupList(this.params.params.baseId); // 获取区域下拉列表
            this.getPeriodList(this.params.params.orgId); // 获取造次下拉列表
            this.getOperationTypeList(); // 获取操作类型下拉列表
            this.getParentByOrgId(this.params.params.orgId); // 获取养殖品种下拉列表
            this.getCustomerList(this.params.params.orgId); //获取客户下拉列表
            this.getTotalTypeList(); // 获取汇总类型下拉列表
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 选择基地
    selectBase(event) {
      this.params.params.groupId = "";
      this.groupList = [];
      this.params.params.boxId = "";
      this.boxList = [];
      this.params.params.periodId = "";
      this.periodList = [];
      this.params.params.breedId = "";
      this.breedList = [];
      this.params.params.clientId = "";
      this.customerList = [];
      this.params.params.orgId = "";
      if (!event) {
        return;
      }
      this.params.params.orgId = this.baseList.filter(
        (item) => item.id === event
      )[0].orgId;
      this.getGroupList(event); // 获取区域下拉列表
      this.getPeriodList(this.params.params.orgId); // 获取造次下拉列表
      this.getParentByOrgId(this.params.params.orgId); // 获取养殖品种下拉列表
      this.getCustomerList(this.params.params.orgId); //获取客户下拉列表
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:08:21
     * @description: 获取权限下的区域
     * @param {*} baseId
     */
    getGroupList(baseId) {
      service
        .queryBaseGroupList(baseId)
        .then((res) => {
          if (res.code == "0000") {
            this.groupList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 选择区域
    selectGroup(event) {
      this.params.params.boxId = "";
      this.boxList = [];
      if (!event) {
        return;
      }
      this.getBoxList(event); // 获取塘口单元
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:18:00
     * @description: 获取塘口单元
     * @param {*} groupId
     */
    getBoxList(groupId) {
      service
        .listDataPermissionBoxData(groupId)
        .then((res) => {
          if (res.code == "0000") {
            this.boxList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:22:28
     * @description: 获取造次列表
     * @param {*} orgId
     */
    getPeriodList(orgId) {
      service
        .getDetailsPeriodList(orgId)
        .then((res) => {
          if (res.code == "0000") {
            // 后端没有把年份跟造次拼接起来，这边处理一下
            const arr = res.data.map((item) => ({
              id: item.id,
              year: item.year + item.makeValue,
            }));
            this.periodList = arr;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:29:34
     * @description: 获取操作类型下拉
     * @param {*}
     */
    getOperationTypeList() {
      service
        .getOperationTypeList()
        .then((res) => {
          if (res.code == "0000") {
            this.operationTypeList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:33:10
     * @description: 获取品种下拉
     * @param {*} orgId
     */
    getBreedList(orgId) {
      service
        .getDetailBreedList(orgId)
        .then((res) => {
          if (res.code == "0000") {
            this.breedList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:38:47
     * @description: 根据当前 机构id获取一级机构id
     * @param {*} orgId
     */
    getParentByOrgId(orgId) {
      service
        .getOrgInfoByOrgId(orgId)
        .then((res) => {
          if (res.code == "0000") {
            const topParentId = res.data.id;
            this.getBreedList(topParentId);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:42:33
     * @description: 获取客户下拉菜单列表
     * @param {*} orgId
     */
    getCustomerList(orgId) {
      service
        .getCustomerList(orgId)
        .then((res) => {
          if (res.code == "0000") {
            this.customerList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:46:12
     * @description: 获取汇总类型
     * @param {*}
     */
    getTotalTypeList() {
      service
        .getTotalTypeList()
        .then((res) => {
          if (res.code == "0000") {
            this.groupTypeList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 重置
    reset() {
      this.params.params.groupId = "";
      this.params.params.boxId = "";
      this.boxList = [];
      this.params.params.periodId = "";
      this.params.params.operationType = "";
      this.params.params.breedId = "";
      this.params.params.clientId = "";
      this.params.params.status = "";
      this.params.params.groupType = "";
      this.dateRange = [];
      this.params.params.startTime = this.$moment().format("YYYY-MM-DD");
      this.params.params.endTime = this.$moment().format("YYYY-MM-DD");
      this.dateRange.push(this.params.params.startTime);
      this.dateRange.push(this.params.params.endTime);
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },

    // 显示的单位-年-月-日
    showListData() {
      if (this.params.params.baseId) {
        this.unitName = this.baseList.filter(
          (item) => item.id == this.params.params.baseId
        )[0].name;
      } else {
        const orgName = localStorage.getItem("orgName");
        this.unitName = orgName;
      }
      this.showStartDate = this.$moment(this.params.params.startTime).format(
        "YYYY年MM月DD日"
      );
      this.showEndDate = this.$moment(this.params.params.endTime).format(
        "YYYY年MM月DD日"
      );
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:53:54
     * @description: 收获记录分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getRecodePageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.params.currPage = res.data.pageNumber;
            this.params.pageSize = res.data.pageSize;
            this.totalCount = res.data.totalCount;
            this.tableData = res.data.list;
            this.showListData();
            this.exportParams = JSON.parse(JSON.stringify(this.params.params));
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-09 14:54:52
     * @description: 导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "月桌面养成收获概览产量-收获记录";
          service
            .exportRecodeData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => { });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 10:59:19
     * @description: 切换当前页
     * @param {*} event
     */
    handleCurrentChange(event) {
      this.params.currPage = event;
      this.getPageList();
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-10 10:59:36
     * @description: 改变当前分页总数
     * @param {*} event
     */
    handleSizeChange(event) {
      this.params.pageSize = event;
      this.params.currPage = 1;
      this.getPageList();
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style lang="less" scoped></style>